import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { CommonService } from '../../services';
import { ManageService } from '../../services/manage.service';
import { SubscriptionApiResponse } from '../../models/api-response.model';
import { Router } from '@angular/router';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-microsoft-cloud-agreement',
  templateUrl: './microsoft-cloud-agreement.component.html',
  styleUrls: ['./microsoft-cloud-agreement.component.css']
})
export class MicrosoftCloudAgreementComponent implements OnInit {

  agreement: FormGroup;
  tenantId: string;
  agreeVersion: string;
  status: string;
  account_validation_messages: any = {
    'firstName': [
      { class: 'firstNameValidatePopup', message: 'Please enter first name' }
    ],
    'lastName': [
      { class: 'lastNameValidatePopup', message: 'Please enter last name' }
    ],
    'email': [
      { class: 'emailValidatePopup', message: 'Please enter email' }
    ]
  };
  loadContent: boolean = false;
  type: string;

  constructor(
    private dialogRef: MatDialogRef<MicrosoftCloudAgreementComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private commonService: CommonService,
    private formBuilder: FormBuilder,
    private manageService: ManageService,
    private router: Router) {
    this.agreement = this.formBuilder.group({
      firstName: new FormControl('', [Validators.required]),
      lastName: new FormControl('', [Validators.required]),
      email: new FormControl('', this.commonService.emailValidatorRegex()),
      phone: new FormControl(''),
    });
  }

  ngOnInit() {
    this.loadContent = false;
    this.agreement.get("firstName").setValue(this.data.firstName);
    this.agreement.get("lastName").setValue(this.data.lastName);
    this.agreement.get("email").setValue(this.data.email);
    this.agreement.get("phone").setValue(this.data.phone);
    this.tenantId = this.data.tenantId;
    this.agreeVersion = this.data.hdnAgreementVersion;
    this.status = this.data.status;
    this.loadContent = true;
    this.type = this.data.type;
  }

  saveUpdates(): void {
    this.loadContent = false;
    if (this.agreement.valid) {
      this.data = {
        firstName: this.agreement.get("firstName").value,
        lastName: this.agreement.get("lastName").value,
        email: this.agreement.get("email").value,
        phone: this.agreement.get("phone").value,
        tenantId: this.tenantId,
        hdnAgreementVersion: this.agreeVersion,
        status: this.status
      }
      this.manageService.updateMSCloudAgreement(JSON.stringify(this.data)).subscribe((res: SubscriptionApiResponse) => {
        if (res && res.status == "Success") {
          this.commonService.implementToast(res.message, 'Info');
         // this.commonService.showSuccess(".saveupdate", res.message, "right");
          setTimeout(() => {
            this.dialogRef.close("Success");
          }, 1000);
        } else {
          this.commonService.showError(".saveupdate", res.message, "right");
        }
        this.loadContent = true;
      },
        (error: any) => {
          console.info(error);
          this.loadContent = true;
        });
    } else {
      this.isNotValidField('firstName', this.account_validation_messages.firstName);
      this.isNotValidField('lastName', this.account_validation_messages.lastName);
      this.isNotValidField('email', this.account_validation_messages.email);
      this.loadContent = true;
    }
  }

  closeAgreementPopup(): void {
    this.dialogRef.close();
  }

  goback(): void {
    if(this.type == "BACK"){
      $('#levelOne').animate({ scrollLeft: 0 }, 400);
      this.router.navigateByUrl("/manageSubscriptions/manageAnnuities/CSP");
      this.dialogRef.close();
    }else{
      this.dialogRef.close();
    }
  }

  onLoading(currentLoadingStatus: boolean) {
    this.loadContent = !currentLoadingStatus;
  }        

  isNotValidField(path: string, validation: any): void {
    if (path == "email") {
      if (this.agreement.get(path).hasError("required")) {
        this.commonService.showError("." + validation[0].class, validation[0].message, "right");
      } else if (this.agreement.get(path).hasError("email")) {
        this.commonService.showError("." + validation[0].class, "Please enter a valid email address", "right");
      }
    } else {
      if (!this.agreement.get(path).valid) {
        this.commonService.showError("." + validation[0].class, validation[0].message, "right");
      }
    }
  }

  isNumberKey(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);

    if (!pattern.test(inputChar)) {
      // invalid character, prevent input
      event.preventDefault();
    }
  }
}
